import axios from "axios";

const VerifyOtp = async ({ oneTimeCode }) => {
  return await axios.post(
    "/marketing-claim-api/v1/auth/validate-one-time-code",
    { one_time_code: oneTimeCode }
  );
};

export { VerifyOtp };
